import styled from 'styled-components';

export const EmbedWrapper = styled.div`
    .video-js {
        position: fixed;
        right: 0;
        bottom: 0;
        min-width: 100%;
        min-height: 100%;
        width: 100%;
        height: auto;
        background-color: #000;
        background-size: cover;
        z-index: 1;
        box-sizing: border-box;
        display: block;
        outline: 0;
        padding: 0 !important;
        overflow: hidden;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        line-height: normal;
    }
`;
